import React from 'react';
import { FastField as Field } from 'formik';
import {
  FormControlLabel as MuiFormControlLabel,
  Switch as MuiSwitch
} from '@material-ui/core';
import { TextString } from '../Text';
import styled from 'styled-components/macro';

const FormControlLabel = styled(MuiFormControlLabel)`
  && {
    ${({ fullWidth }) => fullWidth && { width: '100%', margin: 0 }}
  }

  [class*='MuiTypography-root'] {
    ${({ fullWidth }) => fullWidth && { flex: 1 }}
  }

  [class*='MuiSwitch-root'] {
    ${({ fullWidth }) => fullWidth && { marginRight: -12 }}
  }

  && {
    ${({ centred }) => centred && { margin: 'auto' }}
  }
`;

export const SwitchControl = ({
  centred,
  checked,
  onChange,
  style,
  fullWidth,
  'data-testid': testId,
  ...props
}) => {
  return (
    <FormControlLabel
      centred={centred}
      fullWidth={fullWidth}
      control={
        <MuiSwitch
          {...props}
          checked={checked}
          onChange={onChange}
          inputProps={{ 'data-testid': testId }}
          color="primary"
        />
      }
      style={style}
      label={
        typeof props.label === 'string' ? (
          <TextString content={props.label} />
        ) : (
          props.label
        )
      }
      labelPlacement="start"
    />
  );
};

export default function SwitchField({ name, label, ...props }) {
  return (
    <Field name={name}>
      {({ field, form }) => (
        <SwitchControl
          checked={field.value}
          onChange={() => {
            form.setFieldValue(name, !field.value);
          }}
          label={label}
          {...props}
        />
      )}
    </Field>
  );
}
